import React from 'react';
import { useState, useEffect } from 'react';
import { Redirect } from 'react-router-dom';
import { createHashHistory } from "history";
import useServerData from '../../hooks/useServerData';
import userStore from '../../stores/userStore';
import { getConsumerData } from '../../actions/actionRunner';
import { setConsumerAppData } from '../../actions/actionRunner';
import { Container, Paper, Grid, Button, Divider } from '@material-ui/core';
import { makeStyles, withStyles } from '@material-ui/core/styles';
import { Checkbox, FormGroup, FormControlLabel, Switch, Typography } from '@material-ui/core';
import TermsDialog from '../layouts/TermsDialog';
import MarketingDialog from '../layouts/MarketingDialog';
import StatusBar from '../layouts/StatusBar';
import CustomDialog from '../layouts/CustomDialog';
import ErrorMessageDialog from '../layouts/ErrorMessageDialog';
const useStyles = makeStyles(theme => ({
  mainContainer: {
    flexGrow: 1,
    textAlign: 'center',
    paddingBottom: '100px'
  },
  fieldName: {
    fontWeight: "bold",
    padding: "10px"
  },
  fieldValue: {
    padding: "10px"
  },
  consumerActionContainer: {
    marginTop: "5vh",
    marginBottom: "10vh"
  }
}));
function Home() {
  const classes = useStyles();
  const history = createHashHistory();
  const [token, consumerData] = useServerData();
  const [hasSentTermsChoice, setHasSentTermsChoice] = useState(false);
  const [hasSentMarketingChoice, setHasSentMarketingChoice] = useState(false);
  const [isDialogOpen, setOpenDialog] = useState(false);
  const [dialogTitle, setDialogTitle] = useState('');
  const [dialogContent, setDialogContent] = useState('');
  const [isErrorDialogOpen, setErrorOpenDialog] = useState(false);
  const [errorDialogTitle, setErrorDialogTitle] = useState('');
  const [errorDialogContent, setErrorDialogContent] = useState('');
  const redirectToLogin = () => {
    userStore.resetUserStoreData();
    console.log('redirecting to login');
    setErrorOpenDialog(false);
    // return <Redirect to="/login" />;     
    history.go("/login");
  };
  useEffect(() => {
    // when mounted / updated                     
    let timer = setInterval(function () {
      let contactClosedStatus = userStore.isContactClosed();
      console.log('contactClosedStatus', contactClosedStatus);
      if (contactClosedStatus) {
        clearInterval(timer);
        timer = null;
      } else {
        console.log('Refreshing data...');
        getConsumerData(userStore.getToken()).then().catch(function (res) {
          setErrorDialogTitle('Atentie!');
          if (res.error_message.indexOf('ERR_100') != -1) {
            setErrorDialogContent(() => {
              return /*#__PURE__*/React.createElement(ErrorMessageDialog, {
                message: res.error_message,
                onClick: () => redirectToLogin()
              });
            });
          } else {
            setErrorDialogContent(() => {
              return /*#__PURE__*/React.createElement(ErrorMessageDialog, {
                message: res.error_message,
                onClick: () => setErrorOpenDialog(false)
              });
            });
          }
          setErrorOpenDialog(true);
        });
      }
    }, 5000);

    // when unmounted
    return () => {
      clearInterval(timer);
      timer = null;
    };
  }, []);
  const sendDisclaimerChoice = choice => {
    console.log('choice is', choice);
    const data = {
      token: token,
      confirm: choice ? 1 : 0
    };
    setConsumerAppData(2, data).then(function () {
      setOpenDialog(false);
      setHasSentTermsChoice(true);
    }).catch(function (res) {
      setErrorDialogTitle('Atentie!');
      setErrorDialogContent(() => {
        return /*#__PURE__*/React.createElement(ErrorMessageDialog, {
          message: res.error_message,
          onClick: () => setErrorOpenDialog(false)
        });
      });
      setErrorOpenDialog(true);
    });
  };
  const showDisclaimerDialog = () => {
    setDialogTitle('Termeni si Conditii');
    setDialogContent(() => {
      return /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement(TermsDialog, {
        sendChoice: sendDisclaimerChoice
      }));
    });
    setOpenDialog(true);
  };
  const sendMarketingChoice = choices => {
    const data = {
      token: token,
      opt_in_marketing: choices.opt_in_comm_sms || choices.opt_in_comm_email || choices.opt_in_comm_dm ? 1 : 0,
      opt_in_comm_sms: choices.opt_in_comm_sms ? 1 : 0,
      opt_in_comm_email: choices.opt_in_comm_email ? 1 : 0,
      opt_in_comm_dm: choices.opt_in_comm_dm ? 1 : 0,
      opt_in_mkt_analysis: choices.opt_in_mkt_analysis ? 1 : 0,
      // send_signup_email: choices.send_signup_email ? 1 : 0,
      signature: choices.signature // 'data:image/png;base64,' //
    };
    setConsumerAppData(8, data).then(function () {
      setOpenDialog(false);
      setHasSentMarketingChoice(true);
    }).catch(function (res) {
      setErrorDialogTitle('Atentie!');
      setErrorDialogContent(() => {
        return /*#__PURE__*/React.createElement(ErrorMessageDialog, {
          message: res.error_message,
          onClick: () => setErrorOpenDialog(false)
        });
      });
      setErrorOpenDialog(true);
    });
  };
  const showMarketingTermsDialog = () => {
    setDialogTitle('Acorduri de Marketing');
    setDialogContent(() => {
      return /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement(MarketingDialog, {
        sendChoice: sendMarketingChoice,
        sms: consumerData.opt_in_comm_sms,
        email: consumerData.opt_in_comm_email,
        dm: consumerData.opt_in_comm_dm,
        market: consumerData.opt_in_mkt_analysis
      }));
    });
    setOpenDialog(true);
  };
  if (token === null) {
    return /*#__PURE__*/React.createElement(Redirect, {
      to: "/login"
    });
  } else {
    const DisclaimerButton = () => {
      if (true) {
        return /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement(Button, {
          variant: "contained",
          color: "secondary",
          onClick: showDisclaimerDialog,
          disabled: hasSentTermsChoice
        }, "Confirmati Termenii si Conditiile"));
      } else {
        return null;
      }
    };
    const MarketingButton = () => {
      if (true) {
        return /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement(Button, {
          variant: "contained",
          color: "secondary",
          onClick: showMarketingTermsDialog,
          disabled: hasSentMarketingChoice
        }, "Alegeti Acordurile de Marketing"));
      } else {
        return null;
      }
    };
    const ConsumerTel = () => {
      if (consumerData.tel) {
        return /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement(Grid, {
          item: true,
          xs: 6
        }, /*#__PURE__*/React.createElement(Paper, {
          className: classes.fieldName
        }, "Telefon")), /*#__PURE__*/React.createElement(Grid, {
          item: true,
          xs: 6
        }, /*#__PURE__*/React.createElement(Paper, {
          className: classes.fieldValue
        }, consumerData.tel)));
      } else {
        return null;
      }
    };
    const ConsumerLastname = () => {
      if (consumerData.lastname) {
        return /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement(Grid, {
          item: true,
          xs: 6
        }, /*#__PURE__*/React.createElement(Paper, {
          className: classes.fieldName
        }, "Nume")), /*#__PURE__*/React.createElement(Grid, {
          item: true,
          xs: 6
        }, /*#__PURE__*/React.createElement(Paper, {
          className: classes.fieldValue
        }, consumerData.lastname)));
      } else {
        return null;
      }
    };
    const ConsumerFirstname = () => {
      if (consumerData.firstname) {
        return /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement(Grid, {
          item: true,
          xs: 6
        }, /*#__PURE__*/React.createElement(Paper, {
          className: classes.fieldName
        }, "Prenume")), /*#__PURE__*/React.createElement(Grid, {
          item: true,
          xs: 6
        }, /*#__PURE__*/React.createElement(Paper, {
          className: classes.fieldValue
        }, consumerData.firstname)));
      } else {
        return null;
      }
    };
    const ConsumerSex = () => {
      if (consumerData.sex) {
        return /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement(Grid, {
          item: true,
          xs: 6
        }, /*#__PURE__*/React.createElement(Paper, {
          className: classes.fieldName
        }, "Sex")), /*#__PURE__*/React.createElement(Grid, {
          item: true,
          xs: 6
        }, /*#__PURE__*/React.createElement(Paper, {
          className: classes.fieldValue
        }, consumerData.sex === 'M' ? 'Masculin' : 'Feminin')));
      } else {
        return null;
      }
    };
    const ConsumerDob = () => {
      if (consumerData.dob) {
        return /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement(Grid, {
          item: true,
          xs: 6
        }, /*#__PURE__*/React.createElement(Paper, {
          className: classes.fieldName
        }, "Data Nasterii")), /*#__PURE__*/React.createElement(Grid, {
          item: true,
          xs: 6
        }, /*#__PURE__*/React.createElement(Paper, {
          className: classes.fieldValue
        }, consumerData.dob)));
      } else {
        return null;
      }
    };
    const ConsumerAddress = () => {
      if (consumerData.address_location) {
        return /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement(Grid, {
          item: true,
          xs: 6
        }, /*#__PURE__*/React.createElement(Paper, {
          className: classes.fieldName
        }, "Adresa Postala")), /*#__PURE__*/React.createElement(Grid, {
          item: true,
          xs: 6
        }, /*#__PURE__*/React.createElement(Paper, {
          className: classes.fieldValue
        }, consumerData.address_location.name, ", ", consumerData.address_location.county.name)));
      } else {
        return null;
      }
    };
    const ConsumerEmail = () => {
      if (consumerData.email) {
        return /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement(Grid, {
          item: true,
          xs: 6
        }, /*#__PURE__*/React.createElement(Paper, {
          className: classes.fieldName
        }, "Adresa de Email")), /*#__PURE__*/React.createElement(Grid, {
          item: true,
          xs: 6
        }, /*#__PURE__*/React.createElement(Paper, {
          className: classes.fieldValue
        }, consumerData.email)));
      } else {
        return null;
      }
    };
    const ConsumerCigarette = () => {
      if (consumerData.cigarette) {
        return /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement(Grid, {
          item: true,
          xs: 6
        }, /*#__PURE__*/React.createElement(Paper, {
          className: classes.fieldName
        }, "Ati declarat ca fumati")), /*#__PURE__*/React.createElement(Grid, {
          item: true,
          xs: 6
        }, /*#__PURE__*/React.createElement(Paper, {
          className: classes.fieldValue
        }, consumerData.cigarette.brand.name, " ", consumerData.cigarette.name)));
      } else {
        return null;
      }
    };
    const ConsumerSale = () => {
      if (consumerData.sku) {
        return /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement(Grid, {
          item: true,
          xs: 6
        }, /*#__PURE__*/React.createElement(Paper, {
          className: classes.fieldName
        }, "Ati cumparat")), /*#__PURE__*/React.createElement(Grid, {
          item: true,
          xs: 6
        }, /*#__PURE__*/React.createElement(Paper, {
          className: classes.fieldValue
        }, consumerData.sku_quantity, " x ", consumerData.sku.cigarette.brand.name, " ", consumerData.sku.cigarette.name, " ")));
      } else {
        return null;
      }
    };
    const ConsumerPrize = () => {
      if (consumerData.prize) {
        return /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement(Grid, {
          item: true,
          xs: 6
        }, /*#__PURE__*/React.createElement(Paper, {
          className: classes.fieldName
        }, "Puteti castiga")), /*#__PURE__*/React.createElement(Grid, {
          item: true,
          xs: 6
        }, /*#__PURE__*/React.createElement(Paper, {
          className: classes.fieldValue
        }, consumerData.prize.name)));
      } else {
        return null;
      }
    };
    const ConsumerRefuseReason = () => {
      if (consumerData.status_reason) {
        return /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement(Grid, {
          item: true,
          xs: 12
        }, /*#__PURE__*/React.createElement(Paper, {
          className: classes.fieldName,
          style: {
            color: 'red'
          }
        }, "Ati decis sa refuzati interactiunea")));
      } else {
        return null;
      }
    };
    const pageContent = /*#__PURE__*/React.createElement(Container, {
      className: classes.mainContainer
    }, /*#__PURE__*/React.createElement("div", {
      className: classes.consumerActionContainer
    }, /*#__PURE__*/React.createElement(Grid, {
      container: true,
      spacing: 3
    }, /*#__PURE__*/React.createElement(Grid, {
      item: true,
      xs: 12,
      sm: 6
    }, /*#__PURE__*/React.createElement(DisclaimerButton, null)), /*#__PURE__*/React.createElement(Grid, {
      item: true,
      xs: 12,
      sm: 6
    }, /*#__PURE__*/React.createElement(MarketingButton, null)))), /*#__PURE__*/React.createElement("h3", null, "Detaliile interactiunii dumneavoastra:"), /*#__PURE__*/React.createElement(Grid, {
      container: true,
      spacing: 3
    }, /*#__PURE__*/React.createElement(ConsumerRefuseReason, null), /*#__PURE__*/React.createElement(ConsumerTel, null), /*#__PURE__*/React.createElement(ConsumerLastname, null), /*#__PURE__*/React.createElement(ConsumerFirstname, null), /*#__PURE__*/React.createElement(ConsumerSex, null), /*#__PURE__*/React.createElement(ConsumerDob, null), /*#__PURE__*/React.createElement(ConsumerAddress, null), /*#__PURE__*/React.createElement(ConsumerEmail, null), /*#__PURE__*/React.createElement(Divider, {
      light: true
    }), /*#__PURE__*/React.createElement(ConsumerCigarette, null), /*#__PURE__*/React.createElement(ConsumerSale, null), /*#__PURE__*/React.createElement(ConsumerPrize, null), /*#__PURE__*/React.createElement(Divider, {
      light: true
    })));
    return /*#__PURE__*/React.createElement(Container, null, pageContent, /*#__PURE__*/React.createElement(CustomDialog, {
      open: isDialogOpen,
      setOpen: setOpenDialog,
      title: dialogTitle,
      fullscreen: true
    }, dialogContent), /*#__PURE__*/React.createElement(CustomDialog, {
      open: isErrorDialogOpen,
      setOpen: setErrorOpenDialog,
      title: errorDialogTitle
    }, errorDialogContent));
  }
}
export default Home;